"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dismissAllErrors = dismissAllErrors;
exports.dismissLatestReportDefinitionsError = dismissLatestReportDefinitionsError;
exports.dismissReportListError = dismissReportListError;
exports.dismissReportDefinitionByIdError = dismissReportDefinitionByIdError;
exports.loadLatestReportDefinitions = loadLatestReportDefinitions;
exports.loadReportDefinition = loadReportDefinition;
exports.loadReport = loadReport;
exports.loadReportsIfNeeded = loadReportsIfNeeded;
exports.loadReports = loadReports;

var _reduxActions = require("redux-actions");

var _constants = require("./constants");

var C = _interopRequireWildcard(_constants);

var _API = require("../../API");

var _lodash = require("lodash");

var _actions = require("../user/actions");

var userActions = _interopRequireWildcard(_actions);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};

function isLoading(promiseState) {
    if (promiseState) {
        return promiseState.pending || promiseState.refreshing;
    }
    return false;
}
function dismissAllErrors() {
    return function (dispatch, getState) {
        console.log("dismissAllErrors");
        var a = dismissLatestReportDefinitionsError()(dispatch, getState);
        return Promise.all([dismissLatestReportDefinitionsError()(dispatch, getState), dismissReportDefinitionByIdError()(dispatch, getState), dismissReportListError()(dispatch, getState)]);
    };
}
function dismissLatestReportDefinitionsError() {
    var _this = this;

    return function (dispatch, getState) {
        return __awaiter(_this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
            var promiseState;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            promiseState = getState().reports.latestReportDefinitionsState;
                            return _context.abrupt("return", dismissError(promiseState, C.REPORTS_DEFINITIONS_DISMISS_ERROR, dispatch));

                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));
    };
}
function dismissReportListError() {
    var _this2 = this;

    return function (dispatch, getState) {
        return __awaiter(_this2, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
            var promiseState;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            promiseState = getState().reports.reports;
                            return _context2.abrupt("return", dismissError(promiseState, C.REPORTS_LIST_DISMISS_ERROR, dispatch));

                        case 2:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));
    };
}
function dismissReportDefinitionByIdError() {
    var _this3 = this;

    return function (dispatch, getState) {
        return __awaiter(_this3, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
            var promiseState;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            promiseState = getState().reports.reportDefinitionByIdState;
                            return _context3.abrupt("return", dismissError(promiseState, C.REPORTS_LIST_DISMISS_ERROR, dispatch));

                        case 2:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));
    };
}
function dismissError(promiseState, constant, dispatch) {
    return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        if (isLoading(promiseState)) {
                            _context4.next = 6;
                            break;
                        }

                        _context4.next = 3;
                        return dispatch((0, _reduxActions.createAction)(constant, function () {
                            return null;
                        })());

                    case 3:
                        return _context4.abrupt("return", _context4.sent);

                    case 6:
                        throw Error("can´t dismiss a pending or refreshing PromiseState");

                    case 7:
                    case "end":
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));
}
function loadLatestReportDefinitions() {
    var _this4 = this;

    return function (dispatch, getState) {
        return __awaiter(_this4, void 0, void 0, regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt("return", _API.client.requestReduxType(_API.API.getLatestReportDefinitions(), [C.REPORTS_DEFINITIONS_LATEST, C.REPORTS_DEFINITIONS_LATEST_SUCCESS, C.REPORTS_DEFINITIONS_LATEST_FAILED], dispatch));

                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));
    };
}
function loadReportDefinition(uid) {
    var _this5 = this;

    return function (dispatch, getState) {
        return __awaiter(_this5, void 0, void 0, regeneratorRuntime.mark(function _callee6() {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            return _context6.abrupt("return", _API.client.requestReduxType(_API.API.getReportDefinition(uid), [C.REPORTS_DEFINITION, C.REPORTS_DEFINITION_SUCCESS, C.REPORTS_DEFINITION_FAILED], dispatch));

                        case 1:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));
    };
}
function loadReport(uid) {
    var _this6 = this;

    return function (dispatch, getState) {
        return __awaiter(_this6, void 0, void 0, regeneratorRuntime.mark(function _callee7() {
            var report, status, definition;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            report = void 0;
                            _context7.prev = 1;
                            _context7.next = 4;
                            return _API.client.requestReduxType(_API.API.getReport(uid), [C.REPORTS_GET, C.REPORTS_GET_SUCCESS, C.REPORTS_GET_FAILED], dispatch);

                        case 4:
                            report = _context7.sent;
                            _context7.next = 16;
                            break;

                        case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7["catch"](1);

                            // a 404 error is returned when the report is not found (deleted, also not accessible (no rights))
                            // anyways, we should remove it from the list
                            // becaause a refresh of the list would result in the same
                            // ... unfortunately we can't use the REPORTS_GET_FAILED action for this, because it
                            // does not know which report we tried to refetch!
                            status = (0, _selectn2.default)("response.status", _context7.t0);

                            if (!(status === 404)) {
                                _context7.next = 15;
                                break;
                            }

                            dispatch((0, _reduxActions.createAction)(C.REPORTS_REMOVE, function () {
                                return uid;
                            })());
                            return _context7.abrupt("return", null);

                        case 15:
                            throw _context7.t0;

                        case 16:
                            definition = (0, _lodash.find)(getState().reports.reportDefinitions, function (def, index) {
                                return def.uid === report.definitionUid;
                            });

                            if (definition) {
                                _context7.next = 21;
                                break;
                            }

                            _context7.next = 20;
                            return loadReportDefinition(report.definitionUid)(dispatch, getState);

                        case 20:
                            definition = _context7.sent;

                        case 21:
                            return _context7.abrupt("return", report);

                        case 22:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[1, 7]]);
        }));
    };
}
function loadReportsIfNeeded() {
    var _this7 = this;

    return function (dispatch, getState) {
        return __awaiter(_this7, void 0, void 0, regeneratorRuntime.mark(function _callee8() {
            var currentReports;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            currentReports = (0, _selectn2.default)("reports.reports.value", getState());

                            console.log(currentReports);

                            if (!(currentReports && currentReports.length)) {
                                _context8.next = 6;
                                break;
                            }

                            return _context8.abrupt("return");

                        case 6:
                            dispatch(loadReports());

                        case 7:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));
    };
}
function loadReports() {
    var _this8 = this;

    return function (dispatch, getState) {
        return __awaiter(_this8, void 0, void 0, regeneratorRuntime.mark(function _callee9() {
            var user, reports, reportDefinitions, missingReportDefinitions, uniqSpecificReportDefinitionCalls;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return userActions.loadUserProfile()(dispatch, getState);

                        case 2:
                            user = _context9.sent;
                            _context9.next = 5;
                            return _API.client.requestReduxType(_API.API.getReports(), [C.REPORTS_LIST, C.REPORTS_LIST_SUCCESS, C.REPORTS_LIST_FAILED], dispatch);

                        case 5:
                            reports = _context9.sent;
                            _context9.next = 8;
                            return loadLatestReportDefinitions()(dispatch, getState);

                        case 8:
                            reportDefinitions = _context9.sent;

                            // search for missing report definitions which are not included in latest definitions
                            missingReportDefinitions = (0, _lodash.filter)(reports, function (report, index) {
                                var definition = (0, _lodash.find)(reportDefinitions, function (definition, index) {
                                    return definition.uid === report.definitionUid;
                                });
                                if (!definition) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                            // remove duplicate entries and build requests

                            uniqSpecificReportDefinitionCalls = (0, _lodash.uniqWith)(missingReportDefinitions, function (element1, element2) {
                                return element1.definitionUid === element2.definitionUid;
                            }).map(function (element) {
                                return loadReportDefinition(element.definitionUid)(dispatch, getState);
                            });
                            _context9.next = 13;
                            return Promise.all(uniqSpecificReportDefinitionCalls);

                        case 13:
                            return _context9.abrupt("return", _context9.sent);

                        case 14:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reports/actions.ts
 ** module id = 642
 ** module chunks = 0
 **/